// extracted by mini-css-extract-plugin
export default {"fractionalPowerLevel":"_3sjQw","fraction":"_2DB06"};